import { render, staticRenderFns } from "./ReviewInfo.vue?vue&type=template&id=e5a541ce&scoped=true&"
import script from "./ReviewInfo.vue?vue&type=script&lang=ts&"
export * from "./ReviewInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewInfo.vue?vue&type=style&index=0&id=e5a541ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5a541ce",
  null
  
)

export default component.exports